<template>
  <div class="blog-container">
    <div class="blog-content-container">
      <!-- 左侧博客区域 -->
      <div class="blogs-section">
        <h2 class="section-subtitle">Blogs</h2>
        <div class="blogs-grid">
          <div class="blog-card" v-for="(blog, index) in blogs.slice(0, 4)" :key="'blog-'+index">
            <div class="blog-image">
              <img :src="blog.image" :alt="blog.title">
            </div>
            <div class="blog-content">
              <h3>{{ blog.title }}</h3>
              <div class="blog-meta">
                <span class="blog-date">{{ blog.date }}</span>
                <span class="blog-category">{{ blog.category }}</span>
              </div>
              <p>{{ blog.excerpt }}</p>
              <a href="#" class="read-more">Read More</a>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 右侧视频区域 -->
      <div class="videos-section">
        <h2 class="section-subtitle">Videos</h2>
        <div class="videos-grid">
          <div class="video-card" v-for="(video, index) in videos.slice(0, 2)" :key="'video-'+index">
            <div class="video-container">
              <iframe :src="video.embedUrl" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
            <div class="video-content">
              <h3>{{ video.title }}</h3>
              <p>{{ video.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Blog',
  data() {
    return {
      currentPage: 1,
      itemsPerPage: 6,
      blogs: [
        {
          title: 'IELTS Writing: How to Structure Your Essay',
          image: require('../assets/images/blog1.jpg'),
          date: 'November 10, 2023',
          category: 'IELTS',
          excerpt: 'Learn the essential structure for IELTS writing task 2 essays to maximize your score potential.'
        },
        {
          title: 'Common Mistakes in English Pronunciation',
          image: require('../assets/images/blog2.jpg'),
          date: 'October 25, 2023',
          category: 'Pronunciation',
          excerpt: 'Discover the most common pronunciation mistakes made by non-native English speakers and how to correct them.'
        },
        {
          title: 'Legal English: Key Terminology for International Law',
          image: require('../assets/images/blog3.jpg'),
          date: 'October 12, 2023',
          category: 'Legal English',
          excerpt: 'A comprehensive guide to essential legal terminology for international law practitioners.'
        },
        {
          title: 'Effective Study Habits for Language Learning',
          image: require('../assets/images/blog4.jpg'),
          date: 'September 30, 2023',
          category: 'Study Tips',
          excerpt: 'Develop powerful study habits that will accelerate your language learning progress.'
        },
        {
          title: 'IELTS Speaking: Tips for Part 2 Long Turn',
          image: require('../assets/images/blog5.jpg'),
          date: 'September 15, 2023',
          category: 'IELTS',
          excerpt: 'Master the IELTS speaking part 2 with these proven strategies and example answers.'
        },
        {
          title: 'Business English: Negotiation Phrases You Need to Know',
          image: require('../assets/images/blog6.jpg'),
          date: 'September 5, 2023',
          category: 'Business English',
          excerpt: 'Essential phrases and vocabulary for successful business negotiations in English.'
        },
        {
          title: 'How to Improve Your English Listening Skills',
          image: require('../assets/images/blog7.jpg'),
          date: 'August 22, 2023',
          category: 'Listening',
          excerpt: 'Practical exercises and resources to enhance your English listening comprehension.'
        },
        {
          title: 'IELTS Reading: Time Management Strategies',
          image: require('../assets/images/blog8.jpg'),
          date: 'August 10, 2023',
          category: 'IELTS',
          excerpt: 'Learn how to effectively manage your time during the IELTS reading section.'
        }
      ],
      videos: [
        {
          title: 'IELTS Speaking: Band 9 Sample Answer',
          embedUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
          description: 'Watch a band 9 IELTS speaking test with detailed analysis of what makes it successful.'
        },
        {
          title: 'English Pronunciation: The Schwa Sound',
          embedUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
          description: 'Learn how to correctly pronounce the most common sound in English - the schwa.'
        },
        {
          title: 'Legal English: Contract Terminology Explained',
          embedUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
          description: 'A detailed explanation of common legal terms found in international contracts.'
        },
        {
          title: 'IELTS Writing Task 1: Describing a Graph',
          embedUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
          description: 'Step-by-step guide to analyzing and describing graphs in IELTS writing task 1.'
        }
      ]
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.blogs.length / this.itemsPerPage);
    },
    paginatedBlogs() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.blogs.slice(start, end);
    }
  },
  methods: {
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    }
  }
}
</script>

<style scoped>
.blog-container {
  padding: 2rem 5%;
  background-color: #ffffff;
}

.section-title {
  text-align: center;
  margin-bottom: 3rem;
  font-size: 2.5rem;
  color: #2c3e50;
}

.section-subtitle {
  font-size: 2rem;
  margin-bottom: 1.5rem;
  color: #2c3e50;
  border-bottom: 2px solid #3498db;
  padding-bottom: 0.5rem;
}

.blog-content-container {
  display: flex;
  gap: 2rem;
}

.blogs-section {
  flex: 2;
}

.videos-section {
  flex: 1;
}

.blogs-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, auto);
  gap: 2rem;
}

.blog-card {
  background: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  height: 430px; /* 固定博客卡片高度 */
}

.blog-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);
}

.blog-image {
  height: 200px;
  overflow: hidden;
  flex-shrink: 0; /* 防止图片区域被压缩 */
}

.blog-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: all 0.3s ease;
}

.blog-card:hover .blog-image img {
  transform: scale(1.1);
}

.blog-content {
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  flex: 1; /* 让内容区域填充剩余空间 */
  overflow: hidden; /* 防止内容溢出 */
}

.blog-content h3 {
  font-size: 1.3rem;
  margin-bottom: 0.5rem;
  color: #2c3e50;
}

.blog-meta {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
  font-size: 0.9rem;
  color: #7f8c8d;
}

.blog-content p {
  margin-bottom: 1rem;
  color: #34495e;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3; /* 限制文本显示行数 */
  -webkit-box-orient: vertical;
  flex: 1; /* 让摘要占据剩余空间 */
}

.read-more {
  display: inline-block;
  color: #3498db;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
  margin-top: auto; /* 将"阅读更多"推到底部 */
}

.read-more:hover {
  color: #2980b9;
  text-decoration: underline;
}

.videos-grid {
  display: grid;
  grid-template-rows: repeat(2, auto);
  gap: 2rem;
}

.video-card {
  background: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  height: 430px; /* 设置固定高度与博客卡片一致 */
  display: flex;
  flex-direction: column;
}

.video-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);
}

.video-container {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 比例 */
  height: 0;
  overflow: hidden;
  border-radius: 10px;
  flex: 1;
  max-height: 200px; /* 与博客卡片图片高度一致 */
}

.video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.video-content {
  padding: 1.5rem;
  overflow: hidden;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.video-content h3 {
  font-size: 1.3rem;
  margin-bottom: 0.5rem;
  color: #2c3e50;
}

.video-content p {
  color: #34495e;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  margin-bottom: 1rem;
}

@media (max-width: 992px) {
  .blog-content-container {
    flex-direction: column;
  }
  
  .blogs-section, .videos-section {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .blogs-grid {
    grid-template-columns: 1fr;
  }
}
</style>